import { render, staticRenderFns } from "./07_ap_regimenes.vue?vue&type=template&id=322d214e&scoped=true&"
import script from "./07_ap_regimenes.vue?vue&type=script&lang=js&"
export * from "./07_ap_regimenes.vue?vue&type=script&lang=js&"
import style0 from "./07_ap_regimenes.vue?vue&type=style&index=0&id=322d214e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d214e",
  null
  
)

export default component.exports